// extracted by mini-css-extract-plugin
export default {"loaderOverlay":"loader_loaderOverlay__bO4wl","loaderContainer":"loader_loaderContainer__808I1"};